<template>
    <div>
        <CRow>
            <CCol v-for="article in pages" :key="article.id" md="4">
                <CCard class="mb-3 shadow-sm" @click="openPopup(article)">
                    <img :src="article.urlToImages" class="card-img-top" alt="Article Image" />
                    <CCardBody>
                        <h5 class="card-title">{{ article.title }}</h5>
                        <!-- Action buttons -->
                        <div class="d-flex justify-content-center gap-2 mt-3">
    
                            <img src="../../assets/img/button-view.png" @click.stop="viewList(article)" width="30px" class="m-1" />
                            <img src="../../assets/img/button-upload.png" @click.stop="openPopup(article)" width="30px" class="m-1" />
                        </div>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    
    
        <div v-if="openBanner" class="upload-popup-overlay" @click="closePopup">
            <div class="upload-popup-card" @click.stop>
                <button class="close-btn" @click="closePopup">×</button>
    
                <br />
                <div class="text-left">
                    <CInput v-model="title" label="Title" />
                    <CTextarea v-model="description" label="Description" rows="9" />
                </div>
                <div class="d-flex justify-content-end gap-2">
                    <CButton color="secondary" class="custom-btn-grey text-dark m-1" @click="closePopup">
                        Cancel
                    </CButton>
                    <CButton color="primary" class="btn-modern m-1" @click="updateClass()">
                        Save Changes
                    </CButton>
                </div>
    
            </div>
        </div>
    
        <div v-if="openArticle" class="upload-popup-overlay" @click.self="closeUploadPopup">
            <div class="upload-popup-card">
                <button class="close-btn" @click="closeUploadPopup">×</button>
                <h4 class="popup-title text-left">Upload Article</h4>
    
                <!-- Title -->
                <div class="text-left mt-4">
                    <label>Title</label>
                    <CInput v-model="titleArticle" type="text" placeholder="Enter title..." />
                </div>
    
                <div class="text-left">
                    <label>Description</label>
                    <CTextarea v-model="descriptionArticle" type="text" placeholder="Enter description..." rows="3" />
                </div>
    
                <!-- Link -->
                <div class="text-left">
                    <label>Link</label>
                    <CInput v-model="link" type="text" placeholder="Enter link..." />
                </div>
    
                <!-- Upload Zone -->
                <!-- Upload Zone -->
                <div class="upload-dropzone" @click="triggerFileInput" @dragover.prevent @drop.prevent="handleDrop">
                    <input type="file" ref="fileInput" @change="handleFiles" accept=".png,.jpg,.jpeg" style="display:none" />
    
                    <!-- Show preview if image uploaded -->
                    <div v-if="previewUrl" class="image-preview">
                        <img :src="previewUrl" alt="Preview" class="preview-img" />
                    </div>
    
                    <!-- Otherwise show upload prompt -->
                    <div v-else class="upload-content">
                        <img src="../../assets/img/upload.png" alt="Upload Icon" class="upload-icon" />
                        <p class="upload-text">Browse File</p>
                        <p class="upload-subtitle">Choose a file or drag & drop it here</p>
                        <p class="upload-format-text">PNG, JPG, or JPEG formats, up to 10 MB</p>
                    </div>
                </div>
                <!-- File Preview -->
                <div v-if="uploadedFile" class="file-preview">
                    <span class="file-name">
                                                                    <i class="fa fa-paperclip"></i> {{ uploadedFile.name }}
                                                                  </span>
                    <button class="remove-file" @click="removeFile">×</button>
                </div>
    
                <!-- Submit -->
                <button class="upload-submit-btn" :disabled="!uploadedFile || !titleArticle || !descriptionArticle || !link || isUploading" @click="submitFile">
                                                                  {{ isUploading ? "Uploading..." : "Upload" }}
                                                                </button>
            </div>
        </div>
    
        <!-- ✅ View List Popup -->
        <div v-if="openViewList" class="upload-popup-overlay" @click.self="closeViewList">
            <div class="upload-popup">
                <button class="close-btn" @click="closeViewList">×</button>
                <h4 class="popup-title text-left">View {{ selectedPage.title }} List</h4>
    
                <div v-if="loadingList" class="text-center my-4">
                    <p>Loading...</p>
                </div>
    
                <div v-else>
                    <component :is="getPopupComponent(selectedPage.title)" :category="selectedPage.title" />
                </div>
            </div>
        </div>
    
    
        <div v-if="openMemo" class="upload-popup-overlay" @click.self="closeMemo">
            <div class="upload-popup-card">
                <button class="close-btn" @click="closeMemo">×</button>
                <h4 class="popup-title text-left">Upload Memo</h4>
    
                <!-- Title -->
                <div class="text-left mt-4">
                    <label>Title</label>
                    <CInput v-model="titleMemo" type="text" placeholder="Enter title..." />
                </div>
    
                <div class="text-left">
                    <label>Description</label>
                    <CTextarea v-model="descriptionMemo" type="text" placeholder="Enter description..." rows="3" />
                </div>
    
                <!-- Link -->
                <div class="text-left">
                    <label>Link</label>
                    <CInput v-model="link" type="text" placeholder="Enter link..." />
                </div>
    
                <!-- Upload Zone -->
                <!-- Upload Zone -->
                <div class="upload-dropzone" @click="triggerFileInputMemo" @dragover.prevent @drop.prevent="handleDrop">
                    <input type="file" ref="fileInputMemo" @change="handleFilesMemo" accept=".png,.jpg,.jpeg" style="display:none" />
    
                    <!-- Show preview if image uploaded -->
                    <div v-if="previewUrlMemo" class="image-preview">
                        <img :src="previewUrlMemo" alt="Preview" class="preview-img" />
                    </div>
    
                    <!-- Otherwise show upload prompt -->
                    <div v-else class="upload-content">
                        <img src="../../assets/img/upload.png" alt="Upload Icon" class="upload-icon" />
                        <p class="upload-text">Browse File</p>
                        <p class="upload-subtitle">Choose a file or drag & drop it here</p>
                        <p class="upload-format-text">PNG, JPG, or JPEG formats, up to 10 MB</p>
                    </div>
                </div>
                <!-- File Preview -->
                <div v-if="uploadedFileMemo" class="file-preview">
                    <span class="file-name">
                        <i class="fa fa-paperclip"></i> {{ uploadedFileMemo.name }}
                      </span>
                    <button class="remove-file" @click="removeFileMemo">×</button>
                </div>
    
                <!-- Submit -->
                <button class="upload-submit-btn" :disabled="!uploadedFileMemo || !titleMemo || !descriptionMemo || !link || isUploading" @click="submitMemo">
                                    {{ isUploading ? "Uploading..." : "Upload" }}
                                </button>
            </div>
        </div>
    
        <!-- ✅ Edit Youtube Popup -->
        <div v-if="openYoutube" class="upload-popup-overlay" @click.self="closeYoutube">
            <div class="upload-popup-card">
                <button class="close-btn" @click="closeYoutube">×</button>
                <h4 class="popup-title text-left">Edit Youtube</h4>
    
                <div class="text-left mt-4">
                    <label>URL Video Youtube</label>
                    <CInput v-model="youtubeUrl" type="text" placeholder="Masukkan URL lengkap dari video YouTube" />
                    <small class="text-muted">Masukkan URL lengkap dari video YouTube</small>
                </div>
    
                <div class="d-flex justify-content-end mt-4">
                    <CButton color="secondary" class="custom-btn-grey text-dark m-1" @click="closeYoutube">
                        Cancel
                    </CButton>
                    <CButton color="primary" class="btn-modern m-1" @click="saveYoutube">
                        Simpan
                    </CButton>
                </div>
            </div>
        </div>
    
    
        <!--Slide Promote Popup-->
        <div v-if="openSlidePromote" class="upload-popup-overlay" @click.self="closeSlidePromote">
            <div class="upload-popup-card">
                <button class="close-btn" @click="closeSlidePromote">×</button>
                <h4 class="popup-title text-left">Upload Slide Promote</h4>
    
                <!-- Upload Zone -->
    
                <!-- Title -->
                <div class="text-left mt-4">
                    <label>Url</label>
                    <CInput v-model="urlSlide" type="text" placeholder="Enter title..." />
                </div>
    
                <div class="upload-dropzone" @click="triggerFileInputSlidePromote" @dragover.prevent @drop.prevent="handleDrop">
                    <input type="file" ref="fileInputSlidePromote" @change="handleFilesSlidePromote" accept=".png,.jpg,.jpeg" style="display:none" />
    
                    <!-- Show preview if image uploaded -->
                    <div v-if="previewUrlSlidePromote" class="image-preview">
                        <img :src="previewUrlSlidePromote" alt="Preview" class="preview-img" />
                    </div>
    
                    <!-- Otherwise show upload prompt -->
                    <div v-else class="upload-content">
                        <img src="../../assets/img/upload.png" alt="Upload Icon" class="upload-icon" />
                        <p class="upload-text">Browse File</p>
                        <p class="upload-subtitle">Choose a file or drag & drop it here</p>
                        <p class="upload-format-text">PNG, JPG, or JPEG formats, up to 10 MB</p>
                    </div>
                </div>
                <!-- File Preview -->
                <div v-if="uploadedFileSlidePromote" class="file-preview">
                    <span class="file-name">
                        <i class="fa fa-paperclip"></i> {{ uploadedFileSlidePromote.name }}
                      </span>
                    <button class="remove-file" @click="removeFileSlidePromote">×</button>
                </div>
    
                <!-- Submit -->
                <button class="upload-submit-btn" :disabled="!uploadedFileSlidePromote || isUploading" @click="submitSlidePromote">
                                    {{ isUploading ? "Uploading..." : "Upload" }}
                                </button>
            </div>
        </div>
    
    
        <!--Slide Advertisement Popup-->
        <div v-if="openPoster" class="upload-popup-overlay" @click.self="closePoster">
            <div class="upload-popup-card">
                <button class="close-btn" @click="closePoster">×</button>
                <h4 class="popup-title text-left">Upload Poster</h4>
    
                <!-- Upload Zone -->
    
                <!-- Title -->
                <div class="text-left mt-4">
                    <label>Url</label>
                    <CInput v-model="urlPoster" type="text" placeholder="Enter title..." />
                </div>
    
                <div class="upload-dropzone" @click="triggerFileInputPoster" @dragover.prevent @drop.prevent="handleDrop">
                    <input type="file" ref="fileInputPoster" @change="handleFilesPoster" accept=".png,.jpg,.jpeg" style="display:none" />
    
                    <!-- Show preview if image uploaded -->
                    <div v-if="previewUrlPoster" class="image-preview">
                        <img :src="previewUrlPoster" alt="Preview" class="preview-img" />
                    </div>
    
                    <!-- Otherwise show upload prompt -->
                    <div v-else class="upload-content">
                        <img src="../../assets/img/upload.png" alt="Upload Icon" class="upload-icon" />
                        <p class="upload-text">Browse File</p>
                        <p class="upload-subtitle">Choose a file or drag & drop it here</p>
                        <p class="upload-format-text">PNG, JPG, or JPEG formats, up to 10 MB</p>
                    </div>
                </div>
                <!-- File Preview -->
                <div v-if="uploadedFilePoster" class="file-preview">
                    <span class="file-name">
                        <i class="fa fa-paperclip"></i> {{ uploadedFilePoster.name }}
                      </span>
                    <button class="remove-file" @click="removeFilePoster">×</button>
                </div>
    
                <!-- Submit -->
                <button class="upload-submit-btn" :disabled="!uploadedFilePoster || isUploading" @click="submitPoster">
                                    {{ isUploading ? "Uploading..." : "Upload" }}
                                </button>
            </div>
        </div>


         <!--Slide Advertisement Popup-->
         <div v-if="openAktiviti" class="upload-popup-overlay" @click.self="closeAktiviti">
            <div class="upload-popup-card">
                <button class="close-btn" @click="closeAktiviti">×</button>
                <h4 class="popup-title text-left">Upload Aktiviti</h4>
    
              
    
                <div class="upload-dropzone" @click="triggerFileInputAktiviti" @dragover.prevent @drop.prevent="handleDrop">
                    <input type="file" ref="fileInputAktiviti" @change="handleFilesAktiviti" accept=".png,.jpg,.jpeg" style="display:none" />
    
                    <!-- Show preview if image uploaded -->
                    <div v-if="previewUrlAktiviti" class="image-preview">
                        <img :src="previewUrlAktiviti" alt="Preview" class="preview-img" />
                    </div>
    
                    <!-- Otherwise show upload prompt -->
                    <div v-else class="upload-content">
                        <img src="../../assets/img/upload.png" alt="Upload Icon" class="upload-icon" />
                        <p class="upload-text">Browse File</p>
                        <p class="upload-subtitle">Choose a file or drag & drop it here</p>
                        <p class="upload-format-text">PNG, JPG, or JPEG formats, up to 10 MB</p>
                    </div>
                </div>
                <!-- File Preview -->
                <div v-if="uploadedFileAktiviti" class="file-preview">
                    <span class="file-name">
                        <i class="fa fa-paperclip"></i> {{ uploadedFileAktiviti.name }}
                      </span>
                    <button class="remove-file" @click="removeFileAktiviti">×</button>
                </div>
    
                <!-- Submit -->
                <button class="upload-submit-btn" :disabled="!uploadedFileAktiviti || isUploading" @click="submitAktiviti">
                                    {{ isUploading ? "Uploading..." : "Upload" }}
                                </button>
            </div>
        </div>
    </div>
</template>
  
<script>
import BannerListPopup from "@/views/components/BannerListPopup.vue";
import ArticleListPopup from "@/views/components/ArticleListPopup.vue";
import YoutubeListPopup from "@/views/components/YoutubeListPopup.vue";
import DefaultListPopup from "@/views/components/DefaultListPopup.vue";
import MemoListPopup from "@/views/components/MemoListPopup.vue";
import SlidePromoteListPopup from "@/views/components/SlidePromoteListPopup.vue";
import PosterListPopup from "@/views/components/PosterListPopup.vue";
import AktivitiListPopup from "@/views/components/AktivitiListPopup.vue";

export default {
    components: {
        BannerListPopup,
        ArticleListPopup,
        YoutubeListPopup,
        DefaultListPopup,
        MemoListPopup,
        SlidePromoteListPopup,
        PosterListPopup,
        AktivitiListPopup
    },
    async mounted() {
        this.SessionUserIdNo();
        let isAuth = await this.UserAuth();

        if (isAuth) {
            this.Busy = false;

        } else {
            this.GoToLogin();
        }
    },
    data() {
        return {
            pages: [{
                    id: 1,
                    title: "Banner",
                    description: "Discover how positivity shapes the way students learn and teachers teach.",
                    url: "https://flyhigh.my/article/positive-learning",
                    urlToImages: require('@/assets/img/icon-banner.png'),

                },
                {
                    id: 2,
                    title: "Slide Promote",
                    url: "https://flyhigh.my/article/confidence-kids",
                    urlToImages: require('@/assets/img/icon-slide.png'),

                },
                {
                    id: 3,
                    title: "Memo",
                    url: "https://flyhigh.my/article/confidence-kids",
                    urlToImages: require('@/assets/img/icon-memo.png'),

                },
                {
                    id: 4,
                    title: "Youtube",
                    description: "Discover how positivity shapes the way students learn and teachers teach.",
                    url: "https://flyhigh.my/article/positive-learning",
                    urlToImages: require('@/assets/img/icon-youtube.png'),

                },
                {
                    id: 5,
                    title: "Poster",
                    url: "https://flyhigh.my/article/confidence-kids",
                    urlToImages: require('@/assets/img/icon-advertisement.png'),

                },
                {
                    id: 6,
                    title: "Aktiviti",
                    url: "https://flyhigh.my/article/confidence-kids",
                    urlToImages: require('@/assets/img/icon-activity.png'),

                },
                {
                    id: 7,
                    title: "Pencapaian",
                    description: "Discover how positivity shapes the way students learn and teachers teach.",
                    url: "https://flyhigh.my/article/positive-learning",
                    urlToImages: require('@/assets/img/icon-pencapaian.png'),

                },
                {
                    id: 8,
                    title: "Feedback",
                    url: "https://flyhigh.my/article/confidence-kids",
                    urlToImages: require('@/assets/img/icon-feedback.png'),

                },
                {
                    id: 9,
                    title: "Artikel",
                    url: "https://flyhigh.my/article/confidence-kids",
                    urlToImages: require('@/assets/img/icon-feedback.png'),

                },
            ],
            openBanner: false,
            selectedPage: {},

            //article
            openArticle: false,
            uploadedFile: null, // ✅ single file only
            isUploading: false,
            uploadedFileId: null, // ✅ stores backend FileId
            link: "",
            titleArticle: "",
            descriptionArticle: "",

            //memo
            title: "",
            description: "",
            previewUrl: null,
            titleMemo: "",
            descriptionMemo: "",
            previewUrlMemo: null,


            viewListData: [], // ✅ stores list of uploaded items
            loadingList: false,
            openViewList: false,
            user: {},
            openMemo: false,
            uploadedFileMemo: null,
            openYoutube: false,
            youtubeUrl: "",

            //slidePromote
            previewUrlSlidePromote: null,
            openSlidePromote: false,
            uploadedFileSlidePromote: null,
            urlSlide: null,

            //poster
            previewUrlPoster: null,
            openPoster: false,
            uploadedFilePoster: null,
            urlPoster: null,



             //aktiviti
            openAktiviti: false,
            uploadedFileAktiviti: null,
            previewUrlAktiviti:null
        }
    },
    watch: {
        openArticle(val) {
            document.body.style.overflow = val ? "hidden" : "auto";
        },
        openBanner(val) {
            document.body.style.overflow = val ? "hidden" : "auto";
        },
    },

    methods: {
        SessionUserIdNo() {
            return this.$API
                .get(this.$LoginUserDetailWebs, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.user = response.data;
                    }
                });
        },
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        editArticle(article) {
            console.log("Editing:", article.title)
            // Open modal or navigate to edit page
        },
        openPopup(article) {
            this.selectedPage = { ...article };
            const title = article.title.toLowerCase();

            this.openBanner = false;
            this.openArticle = false;

            if (title === "banner") {
                this.openBanner = true;
            } else if (title === "artikel") {
                this.openArticle = true;
            } else if (title === "memo") {
                this.openMemo = true;
            } else if (title === "youtube") {
                this.openYoutube = true;
            } else if (title === "slide promote") {
                this.openSlidePromote = true;
            } else if (title === "poster") {
                this.openPoster = true;
            } else if (title === "aktiviti") {
                this.openAktiviti = true;
            }
            
            else {
                alert(`No popup is assigned for ${article.title}`);
            }
        },

        closePopup() {
            this.openBanner = false;
        },

        triggerFileInput() {
            this.$refs.fileInput.click();
        },

        handleFiles(e) {
            const file = e.target.files[0];
            this.setFile(file);
        },

        handleDrop(e) {
            const file = e.dataTransfer.files[0];
            this.setFile(file);
        },

        setFile(file) {
            if (!file) return;
            if (!["image/png", "image/jpeg"].includes(file.type)) {
                alert("Only PNG or JPG files allowed!");
                return;
            }
            if (file.size > 10 * 1024 * 1024) {
                alert("File must be under 10MB!");
                return;
            }

            this.uploadedFile = file;

            // ✅ Create live preview
            this.previewUrl = URL.createObjectURL(file);
        },

        removeFile() {
            this.uploadedFile = null;
            this.previewUrl = null;
            this.$refs.fileInput.value = "";
        },

        async submitFile() {
            if (!this.uploadedFile) return;
            this.isUploading = true;

            try {
                const formData = new FormData();
                formData.append("files", this.uploadedFile);

                const res = await this.$API.post(this.$UploadArticle, formData, {
                    withCredentials: true,
                    timeout: 600000,
                });

                const uploaded = res.data[0];
                // ✅ Match backend property names
                if (uploaded.success) {
                    this.uploadedFileId = uploaded.fileId;

                    // 🔴 FIX: Clean the URL string if it contains the "URL: " prefix
                    let cleanUrl = uploaded.fileUrl;
                    const prefix = "URL: ";

                    if (cleanUrl && cleanUrl.startsWith(prefix)) {
                        // Remove the prefix
                        cleanUrl = cleanUrl.substring(prefix.length);
                    }

                    // Assign the cleaned URL
                    this.uploadedFileUrl = cleanUrl;


                    // ✅ Update the "Artikel" card image immediately
                    const artikel = this.pages.find(p => p.title.toLowerCase() === "artikel");

                    // Now use the cleaned URL
                    if (artikel) artikel.urlToImage = this.uploadedFileUrl;

                    await this.submitArticle();
                    alert("✅ File uploaded and article saved successfully!");
                    this.closeUploadPopup();
                } else {
                    alert("❌ Upload failed: " + (uploaded.error || "Unknown error"));
                }
            } catch (err) {
                console.error(err);
                alert("⚠️ Error uploading file.");
            } finally {
                this.isUploading = false;
            }
        },

        // async submitArticle() {
        //     try {
        //         if (!this.titleArticle) {
        //             alert("Please enter a title.");
        //             return;
        //         }

        //         const payload = {
        //             id: 0,
        //             author: "Admin Flyhigh",
        //             title: this.titleArticle,
        //             description: this.descriptionArticle,
        //             url: this.link,
        //             urlToImage: this.uploadedFileUrl || "",
        //             urlSource: "FlyHigh Admin",
        //             likes: 0,
        //             status: "Published",
        //             fileAwsId: this.uploadedFileId || null,
        //         };

        //         const res = await this.$API.post(this.$InsertArticle, payload, {
        //             withCredentials: true,
        //             timeout: 600000,
        //         });

        //         alert("✅ Article saved successfully! ID: " + res.data);
        //         this.resetArticleForm();
        //         this.closeUploadPopup();
        //     } catch (err) {
        //         console.error(err);
        //         alert("⚠️ Failed to save article.");
        //     }
        // },

        //memo
        // 📁 Trigger Memo file input
        triggerFileInputMemo() {
            this.$refs.fileInputMemo.click();
        },

        // 📁 Handle Memo file change
        handleFilesMemo(e) {
            const file = e.target.files[0];
            this.setFileMemo(file);
        },

        // 📁 Handle Memo drag/drop
        handleDropMemo(e) {
            const file = e.dataTransfer.files[0];
            this.setFileMemo(file);
        },

        // 📁 Set Memo file + preview
        setFileMemo(file) {
            if (!file) return;
            if (!["image/png", "image/jpeg"].includes(file.type)) {
                alert("Only PNG or JPG files allowed!");
                return;
            }
            if (file.size > 10 * 1024 * 1024) {
                alert("File must be under 10MB!");
                return;
            }

            this.uploadedFileMemo = file;
            this.previewUrlMemo = URL.createObjectURL(file);
        },

        // 🗑️ Remove Memo file
        removeFileMemo() {
            this.uploadedFileMemo = null;
            this.previewUrlMemo = null;
            this.$refs.fileInputMemo.value = "";
        },

        // 🚀 Upload Memo
        async submitMemo() {
            if (!this.uploadedFileMemo) {
                alert("Please choose a file!");
                return;
            }
            this.isUploading = true;

            try {
                const formData = new FormData();
                formData.append("files", this.uploadedFileMemo);

                const res = await this.$API.post(this.$UploadMemo, formData, {
                    withCredentials: true,
                    timeout: 600000,
                });

                const uploaded = res.data[0];

                if (uploaded.success) {
                    this.uploadedFileId = uploaded.fileId;


                    let cleanUrl = uploaded.fileUrl;
                    const prefix = "URL: ";

                    if (cleanUrl && cleanUrl.startsWith(prefix)) {
                        // Remove the prefix
                        cleanUrl = cleanUrl.substring(prefix.length);
                    }

                    // Assign the cleaned URL
                    this.uploadedFileUrl = cleanUrl;


                    // ✅ Show uploaded image on Memo card
                    const memo = this.pages.find(p => p.title.toLowerCase() === "memo");
                    if (memo) memo.urlToImage = this.uploadedFileUrl;

                    await this.saveMemo();

                    alert("✅ Memo uploaded and saved successfully!");
                    this.closeMemo();
                } else {
                    alert("❌ Upload failed: " + (uploaded.error || "Unknown error"));
                }
            } catch (err) {
                console.error(err);
                alert("⚠️ Error uploading memo file.");
            } finally {
                this.isUploading = false;
            }
        },
        async saveMemo() {
            try {
                if (!this.titleMemo) {
                    alert("Please enter a title.");
                    return;
                }

                const payload = {
                    id: 0,
                    title: this.titleMemo,
                    description: this.descriptionMemo,
                    url: this.link,
                    urlToImage: this.uploadedFileUrl || "",
                    fileAwsId: this.uploadedFileId || null,
                };

                const res = await this.$API.post(this.$InsertMemo, payload, {
                    withCredentials: true,
                    timeout: 600000,
                });

                alert("✅ Memo saved successfully! ID: " + res.data);
            } catch (err) {
                console.error(err);
                alert("⚠️ Failed to save memo.");
            }
        },

        async submitArticle() {
            try {
                if (!this.titleArticle) {
                    alert("Please enter a title.");
                    return;
                }

                const payload = {
                    id: this.selectedPage.id || 0,
                    author: "Nurul Huda",
                    title: this.titleArticle,
                    description: this.descriptionArticle,
                    url: this.link,
                    urlToImage: this.uploadedFileUrl || "",
                    urlSource: "FlyHigh Admin",
                    likes: 0,
                    status:"Published",
                    fileAwsId: this.uploadedFileId || null,
                };

                const res = await this.$API.post(this.$InsertArticle, payload, {
                    withCredentials: true,
                    timeout: 600000,
                });

                alert("✅ Article saved successfully! ID: " + res.data);
                this.resetArticleForm();
                this.closeUploadPopup();
            } catch (err) {
                console.error(err);
                alert("⚠️ Failed to save article.");
            }
        },


        closeUploadPopup() {
            this.openArticle = false;
            this.uploadedFile = null;
        },
        resetArticleForm() {
            this.titleArticle = "";
            this.descriptionArticle = "";
            this.link = "";
            this.uploadedFile = null;
            this.uploadedFileId = null;
            this.uploadedFileUrl = "";
            if (this.$refs.fileInput) this.$refs.fileInput.value = "";
        },
        async viewList(article) {
            this.selectedPage = article;
            this.openViewList = true;
            this.loadingList = false; // No loading since component handles it
        },

        closeViewList() {
            this.openViewList = false;
            this.viewListData = [];
        },

        formatDate(dateStr) {
            if (!dateStr) return "-";
            const d = new Date(dateStr);
            return d.toLocaleDateString("en-MY", {
                year: "numeric",
                month: "short",
                day: "numeric",
            });
        },
        getPopupComponent(title) {
            switch (title.toLowerCase()) {
                case "banner":
                    return "BannerListPopup";
                case "artikel":
                    return "ArticleListPopup";
                case "youtube":
                    return "YoutubeListPopup";
                case "memo":
                    return "MemoListPopup";
                case "slide promote":
                    return "SlidePromoteListPopup";
                case "poster":
                    return "PosterListPopup";
                case "aktiviti":
                    return "AktivitiListPopup";
                default:
                    return "DefaultListPopup";
            }
        },
        updateClass() {

            this.lblBtn = "Processing";
            this.Error = false;
            const formData = new FormData();

            formData.append("Title", this.title);
            formData.append("SubTitle", this.description);
            formData.append("Status", "published");

            return this.$API
                .post(this.$CreateBannerText, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                            alert("Success save");
                            this.closePopup();

                    } else {
                        this.Busy = false;
                        this.$dialog
                            .alert("Error to create ")
                            .then(function() {});
                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        closeMemo() {
            this.openMemo = false;
            this.titleMemo = "";
  this.descriptionMemo = "";
  this.link = "";
  this.uploadedFileMemo = null;
  this.previewUrlMemo = null;
  this.uploadedFileUrl = "";
  this.uploadedFileId = null;
  if (this.$refs.fileInputMemo) this.$refs.fileInputMemo.value = "";
        },
        closeYoutube() {
            this.openYoutube = false;
        },

        saveYoutube() {
            if (!this.youtubeUrl) {
                alert("Sila masukkan URL video YouTube.");
                return;
            }

            // Example API call
            const formData = new FormData();
            formData.append("Link", this.youtubeUrl);

            this.$API.post(this.$InsertYoutube, formData, { withCredentials: true })
                .then((res) => {
                    alert("✅ URL YouTube berjaya disimpan!");
                    this.closeYoutube();
                })
                .catch((err) => {
                    console.error(err);
                    alert("⚠️ Gagal menyimpan URL YouTube.");
                });
        },


        //slide promote
        // 📁 Trigger Memo file input
        triggerFileInputSlidePromote() {
            this.$refs.fileInputSlidePromote.click();
        },

        // 📁 Handle slide file change
        handleFilesSlidePromote(e) {
            const file = e.target.files[0];
            this.setFileSlidePromote(file);
        },

        // 📁 Handle slide drag/drop
        handleDropSlidePromote(e) {
            const file = e.dataTransfer.files[0];
            this.setFileSlidePromote(file);
        },

        // 📁 Set slide file + preview
        setFileSlidePromote(file) {
            if (!file) return;
            if (!["image/png", "image/jpeg"].includes(file.type)) {
                alert("Only PNG or JPG files allowed!");
                return;
            }
            if (file.size > 10 * 1024 * 1024) {
                alert("File must be under 10MB!");
                return;
            }

            this.uploadedFileSlidePromote = file;
            this.previewUrlSlidePromote = URL.createObjectURL(file);
        },

        // 🗑️ Remove slide file
        removeFileSlidePromote() {
            this.uploadedFileSlidePromote = null;
            this.previewUrlSlidePromote = null;
            this.$refs.fileInputSlidePromote.value = "";
        },
        closeSlidePromote() {
            this.openSlidePromote = false;
        },
        // 🚀 Upload slide
        async submitSlidePromote() {
            this.isUploading = true;

            try {
                const formData = new FormData();
                formData.append("file", this.uploadedFileSlidePromote);

                const res = await this.$API.post(this.$UploadFileSlide, formData, {
                    withCredentials: true,
                    timeout: 600000,
                });

                // ✅ Handle both array or object response
                const uploaded = Array.isArray(res.data) ? res.data[0] : res.data;

                if (uploaded.success) {
                    this.uploadedFileId = uploaded.fileId;

                    let cleanUrl = uploaded.fileUrl;
                    const prefix = "URL: ";
                    if (cleanUrl && cleanUrl.startsWith(prefix)) {
                        cleanUrl = cleanUrl.substring(prefix.length);
                    }

                    this.uploadedFileUrl = cleanUrl;

                    const memo = this.pages.find(p => p.title.toLowerCase() === "slide");
                    if (memo) memo.urlToImage = this.uploadedFileUrl;
                    await this.saveSlidePromotion();
                    alert("✅ Slide uploaded and saved successfully!");
                    await this.resetSlidePromoteForm();
                    await this.closeSlidePromote();
                } else {
                    alert("❌ Upload failed: " + (uploaded.error || "Unknown error"));
                }
            } catch (err) {
                console.error(err);
                alert("⚠️ Error uploading slide file.");
            } finally {
                this.isUploading = false;
            }
        },
        resetSlidePromoteForm() {
  this.urlSlide = "";
  this.uploadedFileSlidePromote = null;
  this.previewUrlSlidePromote = null;
  this.uploadedFileId = null;
  this.uploadedFileUrl = "";
  if (this.$refs.fileInputSlidePromote) {
    this.$refs.fileInputSlidePromote.value = "";
  }
},
        async saveSlidePromotion() {
            try {
                if (!this.urlSlide) {
                    alert("Please enter a title.");
                    return;
                }

                const payload = {
                    id: 0,

                    url: this.urlSlide,
                    urlToImage: this.uploadedFileUrl || "",
                    fileAwsId: this.uploadedFileId || null,
                    status: true,
                };

                const res = await this.$API.post(this.$InsertSlidePromotion, payload, {
                    withCredentials: true,
                    timeout: 600000,
                });

                alert("✅ Slide promotion saved successfully! ID: " + res.data);
            
            } catch (err) {
                console.error(err);
                alert("⚠️ Failed to save memo.");
            }
        },


        //slide Poster
        // 📁 Trigger Poster file input
        triggerFileInputPoster() {
            this.$refs.fileInputPoster.click();
        },

        // 📁 Handle Poster file change
        handleFilesPoster(e) {
            const file = e.target.files[0];
            this.setFilePoster(file);
        },

        // 📁 Handle Poster drag/drop
        handleDropPoster(e) {
            const file = e.dataTransfer.files[0];
            this.setFilePoster(file);
        },

        // 📁 Set Poster file + preview
        setFilePoster(file) {
            if (!file) return;
            if (!["image/png", "image/jpeg"].includes(file.type)) {
                alert("Only PNG or JPG files allowed!");
                return;
            }
            if (file.size > 10 * 1024 * 1024) {
                alert("File must be under 10MB!");
                return;
            }

            this.uploadedFilePoster = file;
            this.previewUrlPoster = URL.createObjectURL(file);
        },

        // 🗑️ Remove Poster file
        removeFilePoster() {
            this.uploadedFilePoster = null;
            this.previewUrlPoster = null;
            this.$refs.fileInputPoster.value = "";
        },
        closePoster() {
        this.openPoster = false;
        // clear all fields
        this.urlPoster = "";
        this.uploadedFilePoster = null;
        this.previewUrlPoster = null;
        this.uploadedFileUrl = "";
        this.uploadedFileId = null;
        if (this.$refs.fileInputPoster) this.$refs.fileInputPoster.value = "";
        },
        // 🚀 Upload slide
        async submitPoster() {
            this.isUploading = true;

            try {
                const formData = new FormData();
                formData.append("file", this.uploadedFilePoster);

                const res = await this.$API.post(this.$UploadFilePoster, formData, {
                    withCredentials: true,
                    timeout: 600000,
                });

                // ✅ Handle both array or object response
                const uploaded = Array.isArray(res.data) ? res.data[0] : res.data;

                if (uploaded.success) {
                    this.uploadedFileId = uploaded.fileId;

                    let cleanUrl = uploaded.fileUrl;
                    const prefix = "URL: ";
                    if (cleanUrl && cleanUrl.startsWith(prefix)) {
                        cleanUrl = cleanUrl.substring(prefix.length);
                    }

                    this.uploadedFileUrl = cleanUrl;

                    const memo = this.pages.find(p => p.title.toLowerCase() === "poster");
                    if (memo) memo.urlToImage = this.uploadedFileUrl;
                    await this.savePoster();
                    alert("✅ Slide uploaded and saved successfully!");
                    this.closePoster();
                } else {
                    alert("❌ Upload failed: " + (uploaded.error || "Unknown error"));
                }
            } catch (err) {
                console.error(err);
                alert("⚠️ Error uploading slide file.");
            } finally {
                this.isUploading = false;
            }
        },
        async savePoster() {
            try {
                if (!this.urlPoster) {
                    alert("Please enter a title.");
                    return;
                }

                const payload = {
                    id: 0,

                    url: this.urlPoster,
                    urlToImage: this.uploadedFileUrl || "",
                    fileAwsId: this.uploadedFileId || null,
                };

                const res = await this.$API.post(this.$InsertPoster, payload, {
                    withCredentials: true,
                    timeout: 600000,
                });

                alert("✅ Slide promotion saved successfully! ID: " + res.data);
            } catch (err) {
                console.error(err);
                alert("⚠️ Failed to save memo.");
            }
        },


         //Aktiviti
        // 📁 Trigger Poster file input
        triggerFileInputAktiviti() {
            this.$refs.fileInputAktiviti.click();
        },

        // 📁 Handle Poster file change
        handleFilesAktiviti(e) {
            const file = e.target.files[0];
            this.setFileAktiviti(file);
        },

        // 📁 Handle Poster drag/drop
        handleDropAktiviti(e) {
            const file = e.dataTransfer.files[0];
            this.setFileAktiviti(file);
        },

        // 📁 Set Poster file + preview
        setFileAktiviti(file) {
            if (!file) return;
            if (!["image/png", "image/jpeg"].includes(file.type)) {
                alert("Only PNG or JPG files allowed!");
                return;
            }
            if (file.size > 10 * 1024 * 1024) {
                alert("File must be under 10MB!");
                return;
            }

            this.uploadedFileAktiviti = file;
            this.previewUrlAktiviti = URL.createObjectURL(file);
        },

        // 🗑️ Remove Poster file
        removeFilePoster() {
            this.uploadedFileAktiviti = null;
            this.previewUrlAktiviti = null;
            this.$refs.fileInputAktiviti.value = "";
        },
        closeAktiviti() {
            this.openAktiviti = false;
            // clear all fields
            this.urlAktiviti = "";
            this.uploadedFileAktiviti = null;
            this.previewUrlAktiviti = null;
            this.uploadedFileUrl = "";
            this.uploadedFileId = null;
            if (this.$refs.fileInputAktiviti) this.$refs.fileInputAktiviti.value = "";
        },
        // 🚀 Upload slide
        async submitAktiviti() {
            this.isUploading = true;

            try {
                const formData = new FormData();
                formData.append("file", this.uploadedFileAktiviti);

                const res = await this.$API.post(this.$UploadFileActivity, formData, {
                    withCredentials: true,
                    timeout: 600000,
                });

                // ✅ Handle both array or object response
                const uploaded = Array.isArray(res.data) ? res.data[0] : res.data;

                if (uploaded.success) {
                    this.uploadedFileId = uploaded.fileId;

                    let cleanUrl = uploaded.fileUrl;
                    const prefix = "URL: ";
                    if (cleanUrl && cleanUrl.startsWith(prefix)) {
                        cleanUrl = cleanUrl.substring(prefix.length);
                    }

                    this.uploadedFileUrl = cleanUrl;

                    const memo = this.pages.find(p => p.title.toLowerCase() === "activity");
                    if (memo) memo.urlToImage = this.uploadedFileUrl;
                    await this.saveAktiviti();
                    alert("✅ Aktiviti uploaded and saved successfully!");
                    this.closeAktiviti();
                } else {
                    alert("❌ Upload failed: " + (uploaded.error || "Unknown error"));
                }
            } catch (err) {
                console.error(err);
                alert("⚠️ Error uploading slide file.");
            } finally {
                this.isUploading = false;
            }
        },
        async saveAktiviti() {
            try {
              
                const payload = {
                    id: 0,

                    url: this.urlPoster,
                    urlToImage: this.uploadedFileUrl || "",
                    fileAwsId: this.uploadedFileId || null,
                };

                const res = await this.$API.post(this.$InsertAktiviti, payload, {
                    withCredentials: true,
                    timeout: 600000,
                });

                alert("✅ Slide aktiviti saved successfully! ID: " + res.data);
            } catch (err) {
                console.error(err);
                alert("⚠️ Failed to save memo.");
            }
        },
        removeFileAktiviti() {
            this.uploadedFileAktiviti = null;
            this.previewUrlAktiviti = null;
            this.$refs.fileInputAktiviti.value = "";
        },
        resetAktivitiForm() {
    this.uploadedFileAktiviti = null;
    this.previewUrlAktiviti = null;
    this.$refs.fileInputAktiviti.value = "";
  },
  resetPosterForm() {
    this.uploadedFilePoster = null;
    this.previewUrlPoster = null;
    this.$refs.fileInputPoster.value = "";
    this.urlPoster = "";
  },
  resetArticleForm() {
    this.uploadedFile = null;
    this.previewUrl = null;
    this.titleArticle = "";
    this.descriptionArticle = "";
    this.link = "";
    this.$refs.fileInput.value = "";
  },




    }
}
</script>

<style scoped>
/* Overlay background */

.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
    backdrop-filter: blur(3px);
}

/* Popup box */

.popup-content {
    background: #fff;
    border-radius: 16px;
    padding: 24px;
    width: 400px;
    max-width: 90%;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    animation: popup-fade 0.3s ease-out;
}

/* Animation */

@keyframes popup-fade {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>